import { Injectable } from '@angular/core';
import { Usecase } from '../../../../domain/usecase/usecase.interface';
import { Result } from '../../../../domain/models/http-response.model';
import { ListingsRepository } from '../../../../domain/repositories/listings.repository';
import { ListingQueryParams, ListingCollectionModel } from '../../../../domain/models/listing.model';

@Injectable({ providedIn: 'root' })
export class GetListingsUsecase
  implements Usecase<ListingQueryParams, Promise<Result<ListingCollectionModel, Error>>>
{
  constructor(private listingsRepository: ListingsRepository) {}

  async execute(params: ListingQueryParams) {
    return this.listingsRepository.getListings(params);
  }
}
